var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingleNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.22c-.74-1.47-3.24-2.39-6.71-3.67-.66-.24-1.08-.34-1.27-.88a1.72 1.72 0 01.16-1.58c1.37-1.49 2-3.72 2-6.59 0-3.8-2.6-5.5-5.18-5.5S6.82 2.7 6.82 6.5c0 2.87.68 5.1 2 6.59A1.72 1.72 0 019 14.67c-.19.54-.61.64-1.27.88-3.47 1.28-6 2.2-6.71 3.67A10.55 10.55 0 000 23.5a.5.5 0 00.5.5h23a.5.5 0 00.5-.5 10.55 10.55 0 00-1-4.28z"
  })));
}

export default SvgSingleNeutral;